import React from 'react';

import { Checkbox } from '@mui/material';

import { IBdsCheckbox } from '../../../interfaces/bdsCheckbox';

import './BdsCheckbox.scss';

const BdsCheckbox = ({ name, value, selected, onChange, variant = 'primary', disabled, className }: IBdsCheckbox) => {
  const classNames = ['bds-checkbox', variant, className].join(' ');
  const handleChange = () => {
    if (!disabled) {
      onChange(value);
    }
  };

  return (
    <Checkbox
      className={classNames}
      checked={selected}
      onChange={handleChange}
      value={value}
      name={name}
      disabled={disabled}
    />
  );
};

export default BdsCheckbox;
